<template>
    <div
            class="w-100 h-100 d-flex flex-column justify-content-around align-items-center text-center home--placeholder p-2"
    >
        <template v-if="target === 'post'">
            <h5 class="text-primary my-0 font-weight-bold ml-1">
                <i class="far fa-thumbs-up"/>
                Le saviez-vous ?
            </h5>
            <p class="my-1 text-justify px-2">
                {{user.firstname}}, partagez vos dernières expériences ou impressions sportives avec vos collègues.
            </p>
            <b-btn
                    :to="{name: 'actuality', query:{'action': 'post'}}"
                    variant="primary"
                    class="btn--shadow text-white"
            >
                <i class="fas fa-pencil-alt"/> Publier
            </b-btn>
        </template>
        <template v-else-if="target === 'communities'">
            <h5 class="text-primary my-0 font-weight-bold mb-3">Mes communautés</h5>
            <div v-if="communities.length === 0">
                <p class="text-secondary">Vous n'avez aucune caumunauté</p>
                <b-btn
                        :to="{name: 'communities'}"
                        variant="primary"
                        class="btn--shadow text-white"
                >
                    Rejoindre une communauté
                </b-btn>
            </div>
            <router-link
                    v-else
                    v-for="(community, key) in communities"
                    :key="key"
                    class="mb-2 mbs-1 p-2 d-flex w-100"
                    style="color: unset; text-decoration: unset;"
                    :to="{ name: 'community', params: { id: community.id } }">
                <img
                        v-if="$store.getters['extra/social/community/getAvatarPath'](community)"
                        :src="$store.getters['extra/social/community/getAvatarPath'](community)"
                        alt="avatar"
                        class="mr-2 rounded"
                        style="width: 65px; height: calc(52px - 1rem); object-fit: contain;"
                />
                <div v-else style="width: 65px; min-height: 100%; background: #EEEEEE;" class="mr-2 rounded"></div>
                <div class="flex-grow-1 text-left">
                    <div class="font-weight-bold text-primary">{{ community.name }}</div>
                    <div>{{ community.communityUser.filter(m => m.workflowState === 'accepted').length + 1 }} membres
                    </div>
                </div>
                <div>
                    <b-btn variant="dark" class="font-weight-bold">
                        Rejoindre
                    </b-btn>
                </div>
            </router-link>
        </template>
        <template v-else>
            <h5 class="text-primary my-0 font-weight-bold ml-1">
                <template v-if="isCoach">Organiser ma séance sportive</template>
                <template v-else>Trouver la séance qui me convient</template>
            </h5>
            <p class="my-1 text-justify px-2">
                <template v-if="isCoach">
                    {{user.firstname}}, créez votre séance sportive à l'aide de la fonctionnalité de
                    création de séance.
                </template>
                <template v-else>
                    {{user.firstname}}, utilisez le calendrier afin de trouver la séance sportive qui vous convient.
                </template>
            </p>
            <b-btn :to="{name: 'calendar'}" variant="primary" class="btn--shadow">
                <i class="fas fa-running"/>
                <template v-if="isCoach"> Créer ma séance</template>
                <template v-else> Trouver ma séance</template>
            </b-btn>
        </template>
    </div>
</template>
<script>
    export default {
        name: 'home-placeholder',
        components: {},
        props: {
            element: Object,
            type: String,
            target: {
                type: String,
                default: 'post'
            }
        },
        async mounted() {
            try {
                if (this.user.roles.includes('ROLE_WORKER')) {
                    const promises = this.$store.state.extra.social.community.allowedTypes.map(type => {
                        return this.$store.dispatch('extra/social/community/byType', {type})
                    })
                    await Promise.all(promises)
                }
            } catch (e) {

            }
        },
        computed: {
            user() {
                return this.$store.state.base.account.information
            },
            isWorker() {
                return this.$store.getters['base/account/getIsWorker'](this.user)
            },
            isCoach() {
                return this.$store.getters['base/account/getIsCoach'](this.user)
            },
            communities() {
                return this.$store.state.extra.social.community.types.private_open || []
            }
        }
    }
</script>
